<template>
    <!-- для multi нужно передавать className, для остальных нет -->
    <div
        class="t-select t-input"
        :class="[
            {'_error': data.error, '_valid': data.valid, '_multi': multi, _disabled: data.disabled},
            className,
            data.name,
            data.id ? `_${data.id.toString()}` : ''
        ]"
        @click="visibleList = !visibleList"
    >
        <div class="t-select__head">
            <input
                class="t-select__input"
                v-model="name"
                :placeholder="data.hintField"
                :disabled="true"
            >
            <div v-if="multi" class="t-select-multi" @click.stop>
                <div v-for="(item, index) in data.value" class="t-select-multi__item">
                    <span>{{ item.label }}</span>
                    <svg class="t-select-multi__delete" @click="deleteValue(index, item.id)" width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1 1L9 9M1 9L9 1L1 9Z" stroke="#c0c0cc" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </div>
            </div>
            <svg class="t-select__arrow" :class="{_open: visibleList}" width="9" height="5" viewBox="0 0 9 5" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.13455 4.84913L0 0.728442L0.730893 0L4.5 3.75647L8.26911 0L9 0.728442L4.86545 4.84913C4.66362 5.05029 4.33638 5.05029 4.13455 4.84913Z" fill="#C8C8C8"/>
            </svg>
        </div>
        <transition name="fade">
            <div v-if="visibleList" class="t-select__list" @click.stop>
                <div
                    class="t-select__item"
                    :class="{_active: listItem.active}"
                    v-for="(listItem, j) in data.list"
                    :key="'data-select-list-' + j"
                    @click="setValue(listItem)"
                >
                    {{ listItem.label }}
                    <svg class="t-select__check" width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4232 0.945312L11.3346 1.6368L4.83112 7.88175C4.71542 7.99286 4.54958 8.05642 4.37542 8.05642C4.20127 8.05642 4.03543 7.99286 3.91972 7.88175L0.667969 4.75928L1.57937 4.06779L4.37542 6.75269L10.4232 0.945312Z" fill="#00b0bd"/>
                    </svg>
                </div>
            </div>
        </transition>
    </div>
</template>

<script>
    import Vue from 'vue';

    export default {
        name: "select-custom",
        props: {
            data: Object,
            multi: {
                type: Boolean,
                default: false
            },
            addTo: {
                type: Number,
                default: 0
            },
            className: {
                type: String,
                default: ''
            },
        },
        data() {
            return {
                visibleList: false,
                name: '',
            }
        },
        watch: {
            'data.value': function() {
                this.setName();
            }
        },
        methods: {
            setName() {
                if (!this.multi) {
                    let name = '';
                    this.data.value.forEach((item, index) => {
                        Vue.set(item, 'active', true);
                        if (index < this.data.value.length - 1) {
                            name = name + item.label + ', ';
                        } else {
                            name = name + item.label;
                        }
                    });
                    this.name = name;

                } else {
                    this.data.value.forEach(item => {
                        Vue.set(item, 'active', true);
                    });
                    this.name = this.data.value.length ? ' ' : '';
                }
            },
            setValue(listItem) {
                this.data.error = false;

                if (listItem.active && this.multi) {
                    let index = this.data.value.findIndex(item => item.id === listItem.id);
                    this.data.value.splice(index, 1);
                    Vue.set(listItem, 'active', false);

                } else {
                    this.data.value.forEach((item) => {
                        Vue.set(item, 'active', false);
                    });
                    if (this.multi) {
                        if (this.addTo > 0) {
                            if (this.data.value.length < this.addTo) {
                                this.data.value.push(listItem);
                            } else {
                                this.data.value.splice(0, 1);
                                this.data.value.push(listItem);
                            }
                        } else {
                            this.data.value.push(listItem);
                        }

                    } else {
                        this.data.value.splice(0, 1, listItem);
                        this.visibleList = false;
                    }
                }
            },
            closeList(e) {
                let _this = this;
                let elem = null;
                if (_this.className) {
                    elem = document.querySelector('.t-select.' + _this.className);
                } else if (_this.data.name) {
                    elem = document.querySelector('.t-select.' + _this.data.name);
                } else if (_this.data.id) {
                    elem = document.querySelector('.t-select._' + _this.data.id);
                } else {
                    elem = document.querySelector('.t-select');
                }

                if (elem !== null) {
                    let target = e.target;
                    let its = target === elem || elem.contains(target);
                    if (!its && _this.visibleList) {
                        _this.visibleList = false;
                    }
                }
            },
            deleteValue(index, id) {
                this.data.value.splice(index, 1);
                this.name = this.data.value.length ? ' ' : '';

                this.data.list.forEach(item => {
                    if (item.id === id) {
                        Vue.set(item, 'active', false);
                    }
                });
            },
            clearSelect() {
                this.data.list.forEach((item) => {
                    Vue.set(item, 'active', false);
                });
            },
        },
        mounted() {
            document.addEventListener('click', this.closeList);
            this.setName();
        },
        beforeDestroy() {
            document.removeEventListener('click', this.closeList);
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/ui-components/select-custom/select-custom-dynamic.vue